/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '~/lib/api/axiosClient';
import type { SearchQueryResponse, Search401 } from '../../types/Search.ts';
import type { RequestConfig, ResponseErrorConfig } from '~/lib/api/axiosClient';

function getSearchUrl() {
  const res = { method: 'GET', url: `/managed-jobs` as const };
  return res;
}

/**
 * {@link /managed-jobs}
 */
export async function search(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    SearchQueryResponse,
    ResponseErrorConfig<Search401>,
    unknown
  >({ method: 'GET', url: getSearchUrl().url.toString(), ...requestConfig });
  return res.data;
}
